import React, {useState, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import Swal from "sweetalert2";
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Divider from '@mui/joy/Divider';
import Grid from '@mui/joy/Grid';
import Input from '@mui/joy/Input';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Textarea from '@mui/joy/Textarea';
import { NumericFormat } from 'react-number-format';
//SERVICES  
import ExchangeOperationService from "../../../services/exchangeOperationService";


function ModalViewDayInterm( {handleOpen, isOpen, selected, fundId, refresh, profileId}) {

    const navigate = useNavigate();
    const [notedit, setNotEdit] = useState(true);
    // const [newprice, setNewPrice] = useState(selected.price);
    // const [newescoprice, setNewEscoPrice] = useState(selected.esco_price);
    const [newprice, setNewPrice] = useState();
    const [newescoprice, setNewEscoPrice] = useState();

    useEffect(() => {
        setNewPrice(selected.price)
        setNewEscoPrice(selected.esco_price)
        if (selected.operation_state_id === 2 && selected.blocked_by_user_id === profileId) {
            setNotEdit(false);
        } else {
            setNotEdit(true);
        }
    }, [selected]);

    const saveChanges = () => {
        if(selected.price !== newprice || selected.esco_price !== newescoprice){ 
            const response = ExchangeOperationService.putOperationsPrice(selected.id, {price: newprice, esco_price: newescoprice})
            .then((response) => {
                setNewPrice('')
                setNewEscoPrice('')
                refresh()
                handleOpen(false);
            })
            .catch((error) => {
                if(error.response.status !== 401){
                    Swal.fire({
                        title: 'Ooops?',
                        text: error.response.data.errors[0].detail,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#f13939'
                    })
                }else{
                    sessionStorage.removeItem("userProfile");
                    navigate('/')
                    window.location.reload();
                }
                handleOpen(false);
            })
        }else{ handleOpen(false); }
    }
    
    return (
        <Modal
            aria-labelledby="close-modal-title"
            open={isOpen}
            onClose={() => handleOpen(false) }
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <ModalDialog>
                <ModalClose variant="outlined" />
                <DialogTitle>  Operación Intermediación: #{fundId}</DialogTitle>
                <Divider />
                <DialogContent>
                    <Grid container spacing={2} sx={{ flexGrow: 1 }}>
                        <Grid xs={4}>
                            <FormControl>
                                <FormLabel className="form-labels">Nro. Comitente</FormLabel>
                                {selected.account_model !== null ?
                                    <Input size="md" placeholder="" disabled={true} value={selected.account_model.account} />
                                : 
                                    <Input size="md" placeholder="" disabled={true} />
                                }
                            </FormControl>
                        </Grid>
                        <Grid xs={8}>
                            <FormControl>
                                <FormLabel className="form-labels">Comitente</FormLabel>
                                {selected.account_model !== null ?
                                    <Input size="md" placeholder="" disabled={true} value={selected.account_model.name} />
                                : 
                                    <Input size="md" placeholder="" disabled={true} />
                                }
                            </FormControl>
                        </Grid>
                        <Grid xs={4}>
                            <FormControl>
                                <FormLabel className="form-labels">Segmento</FormLabel>
                                {selected.segment !== null ?
                                    <Input size="md" placeholder="" disabled={true} value={selected.segment.name} />
                                : 
                                    <Input size="md" placeholder="" disabled={true} />
                                }
                            </FormControl>
                        </Grid>
                        { selected.exchange_type_id === 2 &&
                            <Grid xs={4}>
                                <FormControl>
                                    <FormLabel className="form-labels">Tipo de Operación</FormLabel>
                                    {selected.operation_type !== null ?
                                        <Input size="md" placeholder="" disabled={true} value={selected.operation_type.name} />
                                    : 
                                        <Input size="md" placeholder="" disabled={true} />
                                    }
                                </FormControl>
                            </Grid>
                        }
                        <Grid xs={4}>
                            <FormControl>
                                <FormLabel className="form-labels">Plazo de liquidación</FormLabel>
                                {selected.settlement_term !== null ?
                                    <Input size="md" placeholder="" disabled={true} value={selected.settlement_term.name} />
                                : 
                                    <Input size="md" placeholder="" disabled={true} />
                                }
                            </FormControl>
                        </Grid>
                        <Grid xs={4}>
                            <FormControl>
                                <FormLabel className="form-labels">Contraparte</FormLabel>
                                <Input size="md" placeholder="" disabled={true} value={selected.counterparty.name} />
                            </FormControl>
                        </Grid>
                        {selected.exchange_type_id === 2 &&
                            <>
                            <Grid xs={4}>
                                <FormControl>
                                    <FormLabel className="form-labels">Especie</FormLabel>
                                    {selected.ticker !== null ?
                                        <Input size="md" placeholder="" disabled={true} value={selected.ticker} />
                                    : 
                                        <Input size="md" placeholder="" disabled={true} />
                                    }
                                </FormControl>
                            </Grid>
                            <Grid xs={4}>
                                <FormControl>
                                    <FormLabel className="form-labels">Moneda</FormLabel>
                                    {selected.currency !== null ?
                                        <Input size="md" placeholder="" disabled={true} value={selected.currency.name} />
                                    : 
                                        <Input size="md" placeholder="" disabled={true} />
                                    }
                                </FormControl>
                            </Grid>
                            </>
                        }
                        { selected.exchange_type_id === 1 &&
                            <>
                                <Grid xs={4}>
                                    <FormControl>
                                        <FormLabel className="form-labels">Tipo</FormLabel>
                                        <Input size="md" placeholder="" disabled={true} value={selected.currency_exchange_type.name} />
                                    </FormControl>
                                </Grid>
                            </>
                        }
                        <Grid xs={4}>
                            <FormControl>
                                <FormLabel className="form-labels">Cantidad</FormLabel>
                                <NumericFormat 
                                    displayType="input" 
                                    className="form-control" 
                                    value={selected.qty} 
                                    // decimalScale={selected.included.fund.decimals} 
                                    decimalScale={0} 
                                    allowLeadingZeros thousandSeparator="." 
                                    decimalSeparator="," 
                                    disabled="true"
                                /> 
                            </FormControl>
                        </Grid>
                        <Grid xs={4}>
                            <FormControl>
                                <FormLabel className="form-labels">Precio Base</FormLabel>
                                <NumericFormat 
                                    displayType="input" 
                                    className="form-control" 
                                    value={selected.price} 
                                    decimalScale={5}
                                    allowLeadingZeros 
                                    thousandSeparator="." 
                                    decimalSeparator="," 
                                    disabled={notedit}
                                    onValueChange={({floatValue}) => {
                                        setNewPrice(floatValue)
                                    }}
                                /> 
                            </FormControl>
                        </Grid>
                        <Grid xs={4}>
                            <FormControl>
                                <FormLabel className="form-labels">Precio ESCO</FormLabel>
                                <NumericFormat 
                                    displayType="input" 
                                    className="form-control" 
                                    value={selected.esco_price} 
                                    decimalScale={5}
                                    allowLeadingZeros thousandSeparator="." 
                                    decimalSeparator="," 
                                    disabled={notedit}
                                    onValueChange={({floatValue}) => {
                                        setNewEscoPrice(floatValue)
                                    }}
                                /> 
                            </FormControl>
                        </Grid>
                        <Grid xs={4}>
                            <FormControl>
                                <FormLabel className="form-labels">Tomada por</FormLabel>
                                {selected.blocked_by_user_id !== null ?
                                    <Input size="md" placeholder="" disabled={true} value={selected.blocked_by.full_name} />
                                : 
                                    <Input size="md" placeholder="" disabled={true} />
                                }
                            </FormControl>
                        </Grid>
                        <Grid xs={12}>
                            <FormControl>
                                <FormLabel className="form-labels">Observciones</FormLabel>
                                <Textarea
                                    disabled={true}
                                    value={selected.observations}
                                    minRows={4}
                                    maxRows={4}
                                />
                            </FormControl>
                        </Grid>
                        
                    </Grid> 
                </DialogContent>
                <Divider />
                <DialogActions>
                    { !notedit &&
                        <button type="button" className="btn btn-info" onClick={() => saveChanges()}> Guardar </button>                    
                    }
                    <button type="button" className="btn btn-outline-secondary" onClick={() => handleOpen(false)}> Cerrar </button>                    
                </DialogActions>
            </ModalDialog>
        </Modal>

    );
}

export default ModalViewDayInterm;